import { render, staticRenderFns } from "./BowContentMediaDx2.vue?vue&type=template&id=2a83f3ca&"
import script from "./BowContentMediaDx2.vue?vue&type=script&lang=js&"
export * from "./BowContentMediaDx2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BowContentMedia2: require('/workspace/components/organisms/BowContentMedia2/BowContentMedia2.vue').default})
